

export const environment = {
	production: false,
	public_key_recaptcha: '6Lfx29EUAAAAAHq-9kv5WaObm6Ifxexu-U-YWNL8',
	domain: 'http://localhost:4200',
	key_google_maps: 'AIzaSyAOl8GnuiXTb2BrRanWZLw7wfSDBMKjUAc',
	url_server_backend: 'https://locker-hub-dev-backend.vivipost.com',
	envName: 'dev',
	token_chatbot: '78795514-10f0-474f-9ac4-8ff47e4ac7af',
	key: '8931b2d1f025b6a4c701905f58fae0dd928e339065205eade2051602725dd615',
};
